/*global BMap */
import { myConst } from "@config/";
import {
    DATA_TYPE_STREET,
    DATA_TYPE_PARKING,
    DATA_TYPE_OIL,
    DATA_TYPE_NEWENERGY,
} from "@utils/dataType";

export const toggleFullScreen = function (on_off) {
    if (typeof on_off == 'boolean') {
        if (on_off) {
            enterFull();
        } else {
            exitFull();

        }
    } else {
        if (!document.fullscreenElement && // alternative standard method
            !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) { // current working methods
            enterFull();
        } else {
            exitFull();
        }
    }

    function enterFull() {
        if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen();
        }
    }

    function exitFull() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }

};



export function clearAllMarker(map, mkArr) {
    for (let i = mkArr.length - 1; i >= 0; i--) {
        map.removeOverlay(mkArr[i]);
        mkArr.splice(i, 1);
    }
}

export function addStyleNode(id, str) {
    if (document.getElementById(id)) return;
    let styleNode = document.createElement("style");
    styleNode.type = "text/css";
    styleNode.id = id;
    if (styleNode.styleSheet) { //
        styleNode.styleSheet.cssText = str; //ie下要通过 styleSheet.cssText写入.
    } else {
        styleNode.innerHTML = str; //在ff中， innerHTML是可读写的，但在ie中，它是只读的.
    }
    document.getElementsByTagName("head")[0].appendChild(styleNode);
}
// addStyleNode('markerShowEmpty', '#map .marker_icon .top.bg {background-image: url("./static/img/marker_bg_empty.png");} #map .marker_icon .top.res .topText.empty{display:inline-block} #map .marker_icon .top.res .topText.use{display:none}');
// document.querySelector('#markerShowEmpty').remove();

// addStyleNode("hideMarkerText", ".marker_icon .bottom {display: none !important;}");
// if (document.getElementById("hideMarkerText")) document.getElementById("hideMarkerText").remove();





export const makeMarkerHtml = (v, source) => {
    const htmlTp = myConst.markerHtml;
    let html = htmlTp
        .replace("{{type}}", v.type)
        .replace("{{imgBg}}", v.imgBg)
        .replace("{{id}}", v.id)
        .replace('{{name}}', v.name);
    if (source === 'pin') {
        // 只有街道 才在 marker 上显示结果
        if (v.type === DATA_TYPE_STREET) {
            if (v.lastUpdate + myConst.updateTimeout > Date.now()) {
                html = html
                    .replace('{{uCount}}', v.uCount)
                    .replace('{{eCount}}', v.eCount)
                    .replace('{{res}}', 'res');
            }
        }
    } else if (source === 'getItem') {
        const marker_res = !isNaN(v.cCount) ? 'res' : ''; // 如果获取到的没有结果 就不要在 marker 上面显示
        html = html
            .replace('{{uCount}}', v.uCount)
            .replace('{{eCount}}', v.eCount)
            .replace('{{res}}', marker_res)
            .replace('{{selected}}', '__sele__');
    }
    return html;
};
